module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-3-4-744901e0dc3a78f84ffc97b3334472b8.jpg";